import Util from "@/helper/Utility.js";

export function GetFriendConfigModel() {
    this.top = 25;
    this.lastRowKey = null;

    this.getParams = function() {
        var params = {
            top: this.top,
            month: this.month,
            lastRowKey: this.lastRowKey,
        };

        return Util.cleanObjectNullKey(params);
    };
}

export function GetFriendConfigBuilder() {
    this.getFriendConfig = new GetFriendConfigModel();

    this.create = function() {
        return this.getFriendConfig;
    };

    this.setTop = function(top) {
        this.getFriendConfig.top = top;
        return this;
    };

    this.setLastRowKey = function(lastRowKey) {
        this.getFriendConfig.lastRowKey = lastRowKey;
        return this;
    };

    this.setMonth = function(month) {
        this.getFriendConfig.month = month;
        return this;
    };

}
